import type { ApiFetchOfficialProfilePort } from '~/handlers/ports/api-fetch-official-profile.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchOfficialProfileAdapter
  implements ApiFetchOfficialProfilePort
{
  async handle(slug: string): Promise<OfficialProfileDetail | null> {
    const response = await fetch(
      `${getApostatudoApiUrl()}/official-profiles/${slug}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      },
    );

    // 404 = perfil inexistente ou inativo. Não é erro: a página redireciona
    // pro índice, então distinguir dos outros status não muda nada aqui.
    if (!response.ok) {
      if (response.status !== 404) {
        console.warn(
          `[ApiFetchOfficialProfile] API retornou ${response.status} para "${slug}"`,
        );
      }

      return null;
    }

    const json: OfficialProfileApiResponse = await response.json();

    if (!json?.data?.slug) {
      console.warn('[ApiFetchOfficialProfile] Resposta sem perfil:', json);

      return null;
    }

    return json.data;
  }
}
